module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar media = model.media || {}\nvar mediaID = media.mediaID\nvar isImage = media.fileType === 'image'\nvar isFile = media.fileType === 'file'\n%>\n<div>\n<%\nif(mediaID){\nif(config.isEnhanced && (thumb = (model.media || {}).thumb) && isImage){\n%>\n<div class=\"thumb\">\n<img src=\"<%= thumb %>\">\n</div>\n<%\n}\nif(isImage){\n%>\n<table>\n<tbody>\n<tr>\n<td>Bild-ID:</td>\n<td><%= model.media.mediaID %></td>\n</tr>\n<tr>\n<td>Abmaße:</td>\n<td><%= model.media.width %>x<%= model.media.height %></td>\n</tr>\n<tr>\n<td>Größe:</td>\n<td><%= utils.fileSize.format(model.media.sizeInBytes, 2) %></td>\n</tr>\n<tr>\n<td>Upload:</td>\n<td><%= utils.moment(model.media.createdAt).format('DD.MM.YYYY') %> um <%= utils.moment(model.media.createdAt).format('HH:mm') %> Uhr</td>\n</tr>\n<tr>\n<td>Name:</td>\n<td><%= model.media.originalName %></td>\n</tr>\n</tbody>\n</table>\n<%\n} else if(isFile){\n%>\n<table>\n<tbody>\n<tr>\n<td>Datei-ID:</td>\n<td><%= model.media.mediaID %></td>\n</tr>\n<tr>\n<td>Größe:</td>\n<td><%= utils.fileSize.format(model.media.sizeInBytes, 2) %></td>\n</tr>\n<tr>\n<td>Upload:</td>\n<td><%= utils.moment(model.media.createdAt).format('DD.MM.YYYY') %> um <%= utils.moment(model.media.createdAt).format('HH:mm') %> Uhr</td>\n</tr>\n<tr>\n<td>Name:</td>\n<td><%= model.media.originalName %></td>\n</tr>\n</tbody>\n</table>\n<%\n}\nif(utils.collectionSize(media.tags || []) > 0){\n%>\n<ul>\n<%\nfor(var t in media.tags){\n%><li><span><%= media.tags[t].name || 'UNKNOWN TAG' %></span><i class=\"fi fi-tag\"></i></li><%\n}\n%>\n</ul>\n<%\n}\n}\n%>\n</div>"
  , __filename = "components/templates/mediaManagement/mediaDetailsSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var media = model.media || {}
var mediaID = media.mediaID
var isImage = media.fileType === 'image'
var isFile = media.fileType === 'file'

    ; __line = 6
    ; __append("\n<div>\n")
    ; __line = 8
    ; 
if(mediaID){
if(config.isEnhanced && (thumb = (model.media || {}).thumb) && isImage){

    ; __line = 11
    ; __append("\n<div class=\"thumb\">\n<img src=\"")
    ; __line = 13
    ; __append(escapeFn( thumb ))
    ; __append("\">\n</div>\n")
    ; __line = 15
    ; 
}
if(isImage){

    ; __line = 18
    ; __append("\n<table>\n<tbody>\n<tr>\n<td>Bild-ID:</td>\n<td>")
    ; __line = 23
    ; __append(escapeFn( model.media.mediaID ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Abmaße:</td>\n<td>")
    ; __line = 27
    ; __append(escapeFn( model.media.width ))
    ; __append("x")
    ; __append(escapeFn( model.media.height ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Größe:</td>\n<td>")
    ; __line = 31
    ; __append(escapeFn( utils.fileSize.format(model.media.sizeInBytes, 2) ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Upload:</td>\n<td>")
    ; __line = 35
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('DD.MM.YYYY') ))
    ; __append(" um ")
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('HH:mm') ))
    ; __append(" Uhr</td>\n</tr>\n<tr>\n<td>Name:</td>\n<td>")
    ; __line = 39
    ; __append(escapeFn( model.media.originalName ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n")
    ; __line = 43
    ; 
} else if(isFile){

    ; __line = 45
    ; __append("\n<table>\n<tbody>\n<tr>\n<td>Datei-ID:</td>\n<td>")
    ; __line = 50
    ; __append(escapeFn( model.media.mediaID ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Größe:</td>\n<td>")
    ; __line = 54
    ; __append(escapeFn( utils.fileSize.format(model.media.sizeInBytes, 2) ))
    ; __append("</td>\n</tr>\n<tr>\n<td>Upload:</td>\n<td>")
    ; __line = 58
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('DD.MM.YYYY') ))
    ; __append(" um ")
    ; __append(escapeFn( utils.moment(model.media.createdAt).format('HH:mm') ))
    ; __append(" Uhr</td>\n</tr>\n<tr>\n<td>Name:</td>\n<td>")
    ; __line = 62
    ; __append(escapeFn( model.media.originalName ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n")
    ; __line = 66
    ; 
}
if(utils.collectionSize(media.tags || []) > 0){

    ; __line = 69
    ; __append("\n<ul>\n")
    ; __line = 71
    ; 
for(var t in media.tags){

    ; __line = 73
    ; __append("<li><span>")
    ; __append(escapeFn( media.tags[t].name || 'UNKNOWN TAG' ))
    ; __append("</span><i class=\"fi fi-tag\"></i></li>")
    ; 
}

    ; __line = 75
    ; __append("\n</ul>\n")
    ; __line = 77
    ; 
}
}

    ; __line = 80
    ; __append("\n</div>")
    ; __line = 81
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mediaManagement/mediaDetailsSummary.ejs

}